import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import Tabs from '@common/components/tabs';
import NumericInput from '@common/components/numericInput';
import KeyboardInput from '@common/components/InputKeyboard';
import { playerSearchTabs, PlayerSearchTabTypes } from '@app/dev/constants/searchPlayer';
import { findPlayerById, findPlayerByUsername } from '@app/dev/helpers/player';
import LoaderButton from '@common/components/loaderButton';
import PlayerCard from '@app/dev/terminal/components/playerCard';

import './style.scss';

const TransferToUserSearch = ({ player: _player, onNext, onPlayerDelete }) => {
  const [tab, setTab] = useState(PlayerSearchTabTypes.PLAYER_ID);
  const [loading, setLoading] = useState(false);
  const [player, setPlayer] = useState(_player ?? null);
  const [errorMessage, setErrorMessage] = useState('');
  const [value, setValue] = useState('');

  const [{ closePopup }] = useContext(PopupContext);
  const t = useTranslation();

  const changeTab = (option) => {
    setTab(option.value);
    setValue('');
    setErrorMessage('');
    setPlayer(null);
  };

  const searchPlayer = async () => {
    setLoading(true);
    setErrorMessage('');

    const result = tab === PlayerSearchTabTypes.PLAYER_ID
      ? await findPlayerById(value)
      : await findPlayerByUsername(value);

    if (!result.success) setErrorMessage(result.errorMessage);
    else {
      setValue('');
      setPlayer(result.data);
    }

    setLoading(false);
  };

  const handleDelete = () => {
    onPlayerDelete?.();
    setPlayer(null);
    setValue('');
  };

  return (
    <div className="popup-content popup-small transfer-to-user-search-popup">
      <h3 className="popup-title">{t('Transfer')}</h3>

      <i onClick={closePopup} className="global-icon icon-Close close-popup" />

      <p className="popup-subtitle">{t('Search for user to transfer')}</p>
      <div className="popup-main-content">
        <i className="global-icon icon-profile popup-main-icon" />

        <Tabs value={tab} onChange={changeTab} options={playerSearchTabs} />

        {player ? (
          <PlayerCard
            hasDelete
            data={player}
            variant="highlighted"
            onDelete={handleDelete}
          />
        ) : (
          <div className="transfer-to-user-search-player-input input-wrapper">
            <div className={`input-row ${errorMessage ? 'input-row-errored' : ''}`}>
              {tab === PlayerSearchTabTypes.PLAYER_ID
                ? <NumericInput placeholder="Player id" value={value} onChange={setValue} />
                : <KeyboardInput placeholder="Username" type="text" disableSearchIcon onChange={setValue} />}
            </div>
            {errorMessage && <div className="error-message">{t(errorMessage)}</div>}
          </div>
        )}
      </div>

      <LoaderButton
        type="button"
        onClick={player ? () => onNext(player) : searchPlayer}
        className="popup-confirm-button"
        loading={loading}
        disabled={!value.trim() && !player}
      >
        {t(player ? 'Next' : 'Search')}
      </LoaderButton>
    </div>
  );
};

TransferToUserSearch.propTypes = {
  player: PropTypes.object,
  onNext: PropTypes.func,
  onPlayerDelete: PropTypes.func,
};

export default TransferToUserSearch;
